import { Button } from '@mui/material';
import { useState } from 'react';

import { IconAttachFileMS } from '../../../../../../constants/icons';
import {
  DialogActionsBox,
  DialogContainer,
  DialogTextTypography,
  DialogTitleTypography,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from '../styles';

interface ApproveAdministrativeDialogProps {
  docId?: number;
  name: string;
  document: string;
  docLoading: boolean;
  disabled: boolean;
  warning: string;
  handleApprove: (docId?: number) => Promise<void>;
}

export function ApproveAdministrativeDialog({
  docId,
  name,
  document,
  docLoading,
  disabled,
  warning,
  handleApprove,
}: ApproveAdministrativeDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const handleConfirm = (): void => {
    handleApprove(docId).then(() => handleClose());
  };

  return (
    <>
      <Button
        disabled={docLoading || disabled}
        sx={{ maxWidth: '120px', height: '40px' }}
        onClick={handleOpen}
      >
        aprovar
      </Button>
      <StyledDialog open={open} onClose={handleClose}>
        <DialogContainer>
          <DialogTitleTypography>Aprovar {name}</DialogTitleTypography>
          {document && (
            <TextTypography sx={{ justifyContent: 'center' }}>
              {IconAttachFileMS}
              {document}
            </TextTypography>
          )}
          <DialogTextTypography>{warning}</DialogTextTypography>
          <DialogActionsBox my={2.5}>
            <OutlinedButton
              sx={{ maxWidth: '200px', width: '200px', height: '48px' }}
              disabled={docLoading}
              onClick={handleClose}
            >
              cancelar
            </OutlinedButton>
            <Button
              sx={{ width: '200px', height: '48px' }}
              disabled={docLoading}
              onClick={handleConfirm}
            >
              aprovar
            </Button>
          </DialogActionsBox>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
